import type { ComponentType } from '@grafikr/components';
import Splide from '@splidejs/splide';

const Component: ComponentType = (node) => {
  const autoplay = node.dataset.autoplay === 'true';

  const init = async () => {
    new Splide(node, {
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoplay,
      interval: 2500,
      mediaQuery: 'min',
    }).mount();
  };

  init();
};

export default Component;
